import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { NewsletterDto } from '@components/newsletter/model';

@Injectable({ providedIn: 'root' })
export class NewsletterService extends ApiServiceBase<NewsletterDto> {
  constructor() {
    super('newsletter/register', 'newsletter', 'fournierWebservice');
  }
}
